<tlk-select
	[id]="'rx-moulds-select-' + id"
	[label]="label + ':'"
	[formControl]="control"
	[compareWith]="compareWith"
	[getOptionName]="getOptionValue"
	[isDisabled]="isDisabled || isReadOnly"
	[cancelSelectionText]="isCancellable ? ('Selector.ClearSelection' | translate) : ''"
	panelClass="moulds-dropdown__panel"
	(cancelSelectionEvent)="handleCancelSelection($event)"
	(closeEvent)="handlePanelClose()"
>
	<tlk-select-option *ngFor="let mould of options" [value]="mould">
		<div class="moulds-dropdown__image-wrapper">
			<rx-mould-element
				[mould]="mould"
				[isSelected]="mould.Id === (selectedMouldId$ | async)"
				[showName]="false"
			></rx-mould-element>
		</div>
		<div class="moulds-dropdown__mould-name">{{ mould.Name }}</div>
	</tlk-select-option>
</tlk-select>
